import { Routes, Route } from "react-router-dom";
import Login from "../pages/Login/Login";
import CourseListing from "../pages/CourseListing/CourseListing";
import CourseCreation from "../pages/CourseCreation/CourseCreation";
import SigninSuccess from "../pages/SigninSuccess/SigninSuccess";
import ViewCourse from "../pages/ViewCourse/ViewCourse";
import { SessionProvider } from "../components/Hooks/sessionEditContext";
import AuthGuard from "./AuthGuard";
import OrganizationListing from "../pages/Organization/OrganizationListing";
import OrganizationCreation from "../pages/Organization/OrganizationCreation";
import UserConsentListing from "../pages/Users/UserConsentListing";
import UserConsent from "../pages/Users/UserDetails";
import OrganizationsView from "../pages/Organization/OrganizationView/OrganizationView";
import UserConsentsView from "../pages/Users/UserConsentsView";
import EditCerificate from "../pages/EditCerificate/EditCerificate";
import PreviewPdf from "../pages/PreviewPdf/PreviewPdf";
import Faq from "../pages/Faq/Faq";
import PageNotFound from "../pages/PageNotFound/PageNotFound";
import NoPermission from "../pages/NoPermission/NoPermission";
import ProtectedRoute from "./ProtectedRoute";
import { AdminRoles } from "../utils/constants/app-constants";
import CerificateListing from "../pages/CertificateListing/CerificateListing";

const routes = [
  <Route key="login" path="" element={<Login />} />,
  <Route
    key="signin-success"
    path="signin-success"
    element={<AuthGuard component={<SigninSuccess />} />}
  />,
  <Route
    key="course-listing"
    path="course-listing"
    element={<AuthGuard component={<CourseListing />} />}
  />,
  <Route
    key="create-course-home"
    path="create-course/*"
    element={
      <AuthGuard
        component={
          <ProtectedRoute allowedRoles={[AdminRoles.SuperAdmin, AdminRoles.SponsoringAdmin, AdminRoles.MasterTrainer]}>
            <CourseCreation />
          </ProtectedRoute>
        }
      />
    }
  />,
  <Route
    key="view-course"
    path="course/view-course"
    element={<AuthGuard component={<ViewCourse />} />}
  />,
  <Route
    key="organization-listing"
    path="organization-listing"
    element={
      <AuthGuard
        component={
          <ProtectedRoute allowedRoles={[AdminRoles.SuperAdmin]}>
            <OrganizationListing />
          </ProtectedRoute>
        }
      />
    }
  />,
  <Route
    key="organization-creation"
    path="/organization-creation"
    element={
      <AuthGuard
        component={
          <ProtectedRoute allowedRoles={[AdminRoles.SuperAdmin]}>
            <OrganizationCreation />
          </ProtectedRoute>
        }
      />
    }
  />,
  <Route key="user-consent" path="/user-consent" element={<UserConsent />} />,
  <Route
    key="user-consent-request"
    path="/user-consent-request"
    element={
      <AuthGuard
        component={
          <ProtectedRoute
            allowedRoles={[AdminRoles.ApprovingAdmin, AdminRoles.SuperAdmin]}
          >
            <UserConsentListing />
          </ProtectedRoute>
        }
      />
    }
  />,
  <Route
    key="organization-details"
    path="/organization-details/:id"
    element={
      <AuthGuard
        component={
          <ProtectedRoute allowedRoles={[AdminRoles.SuperAdmin]}>
            <OrganizationsView />
          </ProtectedRoute>
        }
      />
    }
  />,
  <Route
    key="user-consent-view"
    path="/user-consent-view/:id"
    element={
      <AuthGuard
        component={
          <ProtectedRoute
            allowedRoles={[AdminRoles.ApprovingAdmin, AdminRoles.SuperAdmin]}
          >
            <UserConsentsView />
          </ProtectedRoute>
        }
      />
    }
  />,
  <Route
    key="edit-certificate"
    path="/edit-certificate/:id"
    element={<AuthGuard component={<EditCerificate />} />}
  />,
  <Route
    key="preview-pdf"
    path="/preview-pdf"
    element={<AuthGuard component={<PreviewPdf />} />}
  />,
  <Route key="faq" path="/faq" element={<AuthGuard component={<Faq />} />} />,
  <Route
    key="page-not-found"
    path="*"
    element={<AuthGuard component={<PageNotFound />} />}
  />,
  <Route
    key="no-permission"
    path="/no-permission"
    element={<AuthGuard component={<NoPermission />} />}
  />,
  <Route
    key="certificate-listing"
    path="/certificate-listing"
    element={<AuthGuard component={<CerificateListing />} />}
  />,
];

export default () => (
  <SessionProvider>
    <Routes>{routes}</Routes>
  </SessionProvider>
);
